import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-move-down', 'IconArrowMoveDown', [
  ['path', { d: 'M12 11v10', key: 'svg-0' }],
  ['path', { d: 'M9 18l3 3l3 -3', key: 'svg-1' }],
  ['path', { d: 'M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-2' }],
]);
